// extracted by mini-css-extract-plugin
export default {"wrap":"ZK-z","fullWidth":"_K-z","hideOnDesktop":"aL-z","content":"bL-z","hasOpenedNav":"cL-z","crumbsList":"dL-z","dropdownsWrap":"eL-z"};